import {Component, HostListener} from '@angular/core';
import {ModalService} from '../../../shared/services/modal.service';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone : false,
})
export class HeaderComponent {
    isScrolled = false;
    isMobileMenuOpen = false;
    isModalOpen = false;
    isModalVisible = false;
    previousScrollPosition = 0;
    modalTriggered = false;


    constructor(private modalService: ModalService) {
        this.modalService.modalState$.subscribe(state => {
            this.isModalOpen = state;
            if (state) {
                setTimeout(() => {
                    this.isModalVisible = true;
                }, 100);
            }
        });
    }
    openModal() {
        this.modalService.openModal();
    }

    closeModal() {
        this.isModalOpen = false;
        this.isModalVisible = false;
        this.modalService.closeModal();
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.isScrolled = window.scrollY > 0;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > this.previousScrollPosition && scrollTop >= 500 && !this.modalTriggered) {
            this.openModal();
            this.modalTriggered = true;
        }
        this.previousScrollPosition = scrollTop;
    }

    toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }
    onTransitionEnd() {
        if (!this.isModalVisible) {
            this.isModalOpen = false;
        }
    }

    formSubmission(event: any) {
        if (event) {
            this.closeModal();
        }
    }
}

